import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-company-files-container',
    templateUrl: './company-files-container.component.html',
    styleUrls: ['./company-files-container.component.css'],
    standalone: false
})
export class CompanyFilesContainerComponent implements OnInit {
  companyId = '';
  constructor(private _route: ActivatedRoute) {}
  ngOnInit(): void {
    this.companyId = this._route.snapshot.paramMap.get('companyId') ?? '';
  }
}
